<template>
  <div class="business">
    <div class="header">
      <p>整合渠道-合作共赢</p>
    </div>
    <div class="guoyi animate__animated wow animate__fadeInUp">
      <titleCard title="国医通战略布局"></titleCard>
      <div class="map-box" ref="myMap">
        <div class="map">
          <!-- <div class="onebox">
            <div class="one">
              <div class="image">
                <img src="../assets/image/business/one/1.png" alt="" />
              </div>
              <div class="text">
                <h3>开能康德威健康科技（北京）有限责任公司</h3>
                <p>2019-03-08 成立</p>
              </div>
            </div>
            <div class="one">
              <div class="image">
                <img src="../assets/image/business/one/2.png" alt="" />
              </div>
              <div class="text">
                <h3>国医延长（北京）医学技术服务有限公司</h3>
                <p>2018-09-06 成立</p>
              </div>
            </div>
            <div class="one">
              <div class="image">
                <img src="../assets/image/business/one/3.png" alt="" />
              </div>
              <div class="text">
                <h3>北京德佳创新医疗器械有限公司</h3>
                <p>2014-11-14 成立</p>
              </div>
            </div>
            <div class="one">
              <div class="image">
                <img src="../assets/image/business/one/4.png" alt="" />
              </div>
              <div class="text">
                <h3>耘医通（北京）信息技术有限公司</h3>
                <p>2021-03-09 成立</p>
              </div>
            </div>
          </div>
          <div class="twobox">
            <div class="two">
              <div class="image">
                <img src="../assets/image/business/two/1.png" alt="" />
              </div>
              <div class="text">
                <h3 style="color: #64b383">哈尔滨辰祥医福科技发展有限公司</h3>
                <p>2015-05-06 成立</p>
              </div>
            </div>
            <div class="two">
              <div class="image">
                <img src="../assets/image/business/two/2.png" alt="" />
              </div>
              <div class="text">
                <h3 style="color: #3cb3b8">
                  国医通（北京）科技发展有限公司内蒙古分公司
                </h3>
                <p>2019-07-01 成立</p>
              </div>
            </div>
            <div class="two two2">
              <div class="image">
                <img src="../assets/image/business/two/3.png" alt="" />
              </div>
              <div class="text">
                <h3 style="color: #45cbd5">
                  国医通（北京）科技发展有限公司山东分公司
                </h3>
                <p>2018-11-27 成立</p>
              </div>
            </div>
            <div class="two two3">
              <div class="image">
                <img src="../assets/image/business/two/4.png" alt="" />
              </div>
              <div class="text">
                <h3 style="color: #f3704a">
                  国医通（江苏）医疗科技发展有限公司
                </h3>
                <p>2022-01-24 成立</p>
              </div>
            </div>
            <div class="two">
              <div class="image">
                <img src="../assets/image/business/two/5.png" alt="" />
              </div>
              <div class="text">
                <h3 style="color: #ee8162">国医通（厦门）科技发展有限公司</h3>
                <p>2021-10-22 成立</p>
              </div>
            </div>
          </div> -->
        </div>
        <div class="p">
          <p class="one">
            业务范围已覆盖除西藏、<br />
            台湾外的所有省市自治区。
          </p>
          <!-- <p class="two">全国范围库房数量达<span>30+</span></p> -->
        </div>
      </div>
    </div>
    <div class="changjing">
      <div class="title">
        <titleCard title="场景解决方案"></titleCard>
      </div>
      <!-- PC -->
      <div class="content-box">
        <div class="box">
          <div
            class="box-pic animate__animated wow animate__fadeInLeft"
            data-wow-duration="1s"
          >
            <img
              src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/C1A7E390B1CE4775AAA584E64A4087E2-6-2.png"
              alt=""
            />
          </div>
          <div
            class="box-txt animate__animated wow animate__fadeInRight"
            data-wow-duration="1.4s"
          >
            <p>
              在现有7家分公司的基础上，多层面的整合渠道资源，<br />
              通过渠道结构整合、渠道关系整合、渠道流程整合、<br />
              渠道终端整合、与价格品牌等营销渠道要素的整合、 <br />
              与客户层面的整合，构建公司因地制宜的渠道系统，<br />
              形成混合、垂直或水平的多渠道系统。
            </p>
          </div>
        </div>
        <div class="box">
          <div
            class="box-txt animate__animated wow animate__fadeInLeft"
            data-wow-duration="1.4s"
          >
            <p>
              在构建渠道系统的同时，兼顾上游工业厂家、下游<br />
              终端客户的诉求，形成国医通特有的合作共赢的商<br />
              业氛围。
            </p>
          </div>
          <div
            class="box-pic animate__animated wow animate__fadeInRight"
            data-wow-duration="1s"
          >
            <img
              src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/4E96C123D9AD45619631FD3992E44B2B-6-2.png"
              alt=""
            />
          </div>
        </div>
        <div class="box">
          <div
            class="box-pic animate__animated wow animate__fadeInLeft"
            data-wow-duration="1s"
          >
            <img
              src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/406F2E78CB5D4E54969E836E5570BE88-6-2.png"
              alt=""
            />
          </div>
          <div
            class="box-txt animate__animated wow animate__fadeInRight"
            data-wow-duration="1.4s"
          >
            <h3>专注为客户提供一站式仓库托管服务</h3>
            <p>
              为客户节约时间，为客户节约成本，做客户放心的后勤管家，<br />解决客户仓储的后顾之忧！
            </p>
          </div>
        </div>
      </div>
      <!-- IOS -->
      <div class="content-Iosbox">
        <div class="box animate__animated wow animate__fadeInUp">
          <div class="pic">
            <img
              src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/C1A7E390B1CE4775AAA584E64A4087E2-6-2.png"
              alt=""
            />
          </div>
          <div class="txt">
            <p>
              在现有7家分公司的基础上，多层面的整合渠道资源，通过渠道结构整合、渠道关系整合、渠道流程整合、
              渠道终端整合、与价格、品牌等营销渠道要素的整合、
              与客户层面的整合，构建公司因地制宜的渠道系统，
              形成混合、垂直或水平的多渠道系统。
            </p>
          </div>
        </div>
        <div class="box animate__animated wow animate__fadeInUp">
          <div class="pic">
            <img
              src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/4E96C123D9AD45619631FD3992E44B2B-6-2.png"
              alt=""
            />
          </div>
          <div class="txt">
            <p>
              在构建渠道系统的同时，兼顾上游工业厂家、下游终端客户的诉求，形成国医通特有的合作共赢的商业氛围。
            </p>
          </div>
        </div>
        <div class="box animate__animated wow animate__fadeInUp">
          <div class="pic">
            <img
              src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/406F2E78CB5D4E54969E836E5570BE88-6-2.png"
              alt=""
            />
          </div>
          <div class="txt">
            <h3>专注为客户提供一站式仓库托管服务</h3>
            <p>
              为客户节约时间，为客户节约成本，做客户放心的后勤管家，解决客户仓储的后顾之忧！
            </p>
          </div>
        </div>
      </div>
      <div class="hezuo animate__animated wow animate__fadeInUp">
        <titleCard title="合作伙伴"></titleCard>
      </div>
    </div>
    <div class="hezuo-content animate__animated wow animate__fadeInUp">
      <!-- PC展示 -->
      <div class="cards">
        <div class="cardX">
          <div class="card">
            <img
              src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/1B9D1AAC65534FD2A1E780DE8F0A85A4-6-2.png"
            />
          </div>
          <div class="card">
            <img
              src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/480B4210DD06439CA931756D796BF9C7-6-2.png"
            />
          </div>
          <div class="card">
            <img
              src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/A7703FC4E812456BB1550D4BD72F459C-6-2.png"
            />
          </div>
          <div class="card">
            <img
              src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/D321026AD4CE4204879292F3F9925E70-6-2.png"
            />
          </div>
        </div>
        <div class="cardX">
          <div class="card">
            <img
              src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/ACE6F96BAD4948E0836D2A8A36202FDA-6-2.png"
            />
          </div>
          <div class="card">
            <img
              src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/336C6E70AFD24CCAABC9CB408F57F4CE-6-2.png"
            />
          </div>
          <div class="card">
            <img
              src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/DF417C5EA9D04C01BCE9D8108F0C2F0F-6-2.png"
            />
          </div>
          <div class="card">
            <img
              src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/979AC949147240B68A81705A7E47F6C7-6-2.png"
            />
          </div>
        </div>
        <div class="cardX">
          <div class="card">
            <img
              src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/6A1B8FD0FB5441FFB3642481EEE80502-6-2.png"
            />
          </div>
          <div class="card">
            <img
              src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/50BFD26434BD4452BAAE0A48D4D26414-6-2.png"
            />
          </div>
          <div class="card">
            <img
              src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/E18D7365897D4DAA973C6F37FC88578D-6-2.png"
            />
          </div>
          <div class="card">
            <img
              src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/9920DC7177E043D4B005F6073222B54C-6-2.png"
            />
          </div>
        </div>
      </div>
      <!-- IOS展示 -->
      <div class="cardIos">
        <div class="card">
          <img
            src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/1B9D1AAC65534FD2A1E780DE8F0A85A4-6-2.png"
          />
        </div>
        <div class="card">
          <img
            src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/480B4210DD06439CA931756D796BF9C7-6-2.png"
          />
        </div>
        <div class="card">
          <img
            src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/A7703FC4E812456BB1550D4BD72F459C-6-2.png"
          />
        </div>
        <div class="card">
          <img
            src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/D321026AD4CE4204879292F3F9925E70-6-2.png"
          />
        </div>
        <div class="card">
          <img
            src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/ACE6F96BAD4948E0836D2A8A36202FDA-6-2.png"
          />
        </div>
        <div class="card">
          <img
            src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/336C6E70AFD24CCAABC9CB408F57F4CE-6-2.png"
          />
        </div>
        <div class="card">
          <img
            src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/DF417C5EA9D04C01BCE9D8108F0C2F0F-6-2.png"
          />
        </div>
        <div class="card">
          <img
            src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/979AC949147240B68A81705A7E47F6C7-6-2.png"
          />
        </div>
        <div class="card">
          <img
            src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/6A1B8FD0FB5441FFB3642481EEE80502-6-2.png"
          />
        </div>
        <div class="card">
          <img
            src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/50BFD26434BD4452BAAE0A48D4D26414-6-2.png"
          />
        </div>
        <div class="card">
          <img
            src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/E18D7365897D4DAA973C6F37FC88578D-6-2.png"
          />
        </div>
        <div class="card">
          <img
            src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/9920DC7177E043D4B005F6073222B54C-6-2.png"
          />
        </div>
      </div>
      <p>— 部分展示 —</p>
    </div>
    <footerCard name="陈老师" phone="138-1017-5809"></footerCard>
  </div>
</template>

<script>
import WOW from "../../node_modules/wowjs/dist/wow";
import titleCard from "../components/title-card.vue";
import footerCard from "../components/footer-card.vue";
export default {
  data() {
    return {};
  },
  components: {
    titleCard,
    footerCard,
  },
  created() {},
  mounted() {
    this.$refs.myMap.scrollLeft = 180;
  },
  methods: {},
};
</script>

<style scoped lang="scss">
.business {
  // background-color: #fbfbfb;
  .header {
    height: 5.2632rem;
    width: 100%;
    display: flex;
    background-color: lightblue;
    align-items: center;
    margin-bottom: 0.8421rem;
    background: url("https://yyt-ows.oss-cn-beijing.aliyuncs.com/31B470ECC2BF4B25A1695275C1A46FE4-6-2.png")
      no-repeat;
    background-size: 100% 100%;
    justify-content: center;
    @media screen and (max-width: 540px) {
      background-size: 230% 100%;
      background-position: center;
      height: 250px;
    }
    p {
      color: #ffffff;
      text-align: center;
      letter-spacing: 0.0421rem;
      font-size: 0.4211rem;
      font-weight: 700;
      text-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
      @media screen and (max-width: 540px) {
        font-size: 20px;
      }
    }
  }
  .guoyi {
    .map-box::-webkit-scrollbar {
      display: none;
    }
    .map-box {
      .map {
        margin-top: 1rem;
        width: 100%;
        height: 100%;
        background: url("https://yyt-ows.oss-cn-beijing.aliyuncs.com/DC8631FD7C654992B889967FFFC764D0-6-2.png")
          no-repeat;
        background-size: 100% 100%;
        @media screen and (max-width: 540px) {
          background: url("https://yyt-ows.oss-cn-beijing.aliyuncs.com/DC8631FD7C654992B889967FFFC764D0-6-2.png")
            no-repeat;
          background-size: cover;
          background-position: 50%;
          width: 880px;
        }
        .onebox {
          @media screen and (max-width: 540px) {
            display: none;
          }
          position: absolute;
          left: 2.2rem;
          top: 0.4rem;
          width: 9rem;
          height: 3rem;
          display: flex;
          flex-wrap: wrap;
          align-items: flex-end;
          .one {
            width: 50%;
            height: 0.8rem;
            display: flex;
            align-items: center;
            .image {
              width: 0.8rem;
              height: 0.8rem;
              margin-right: 0.1rem;
              img {
                width: 100%;
                height: 100%;
              }
            }
            .text {
              font-size: 0.18rem;
              h3 {
                font-size: 0.18rem;
                margin: 0;
                color: #0ca6eb;
                margin-bottom: 0.1rem;
              }
            }
          }
        }
        .twobox {
          @media screen and (max-width: 540px) {
            display: none;
          }
          position: absolute;
          right: 2.1rem;
          top: 1.7rem;
          width: 5rem;
          height: 5rem;
          .two2 {
            margin-bottom: 0.21rem !important;
          }
          .two3 {
            margin-bottom: 0.45rem !important;
          }
          .two {
            width: 100%;
            height: 0.8rem;
            display: flex;
            align-items: center;
            margin-bottom: 0.4rem;
            .image {
              width: 0.8rem;
              height: 0.8rem;
              margin-right: 0.1rem;
              img {
                width: 100%;
                height: 100%;
              }
            }
            .text {
              font-size: 0.2rem;
              h3 {
                font-size: 0.19rem;
                margin: 0;
                color: #0ca6eb;
                margin-bottom: 0.1rem;
              }
            }
          }
        }
      }
      background-color: #ffffff !important;
      margin-bottom: 0.1684rem;
      height: 11.1579rem;
      width: 100%;
      position: relative;
      @media screen and (max-width: 540px) {
        height: 550px;
        margin-bottom: 30px;
        overflow: scroll;
        overflow-y: hidden;
      }
      .p {
        position: absolute;
        left: 1.7684rem;
        bottom: 0.9263rem;
        color: #333333;
        line-height: 0.5053rem;
        font-size: 0.3368rem;
        @media screen and (max-width: 540px) {
          left: 10px;
          bottom: 0;
          font-size: 16px;
          line-height: 28px;
        }
        span {
          font-size: 0.5895rem;
          padding: 0 0.1053rem;
          color: #0ca6eb;
          font-weight: 700;
          @media screen and (max-width: 540px) {
            font-size: 28px;
          }
        }
        .one {
          padding-bottom: 0.5263rem;
        }
        .two {
          display: flex;
        }
      }
    }
  }
  .changjing {
    background-color: #fff;
    .title {
      padding: 1.0526rem 0 1.9474rem 0;
    }
    .content-box {
      padding: 0 1.7053rem;
      @media screen and (max-width: 540px) {
        display: none;
      }
      .box {
        display: flex;
        align-items: center;
        height: 5.1579rem;
        padding-bottom: 0.6947rem;
        .box-pic {
          height: 5.1579rem;
          flex: 1;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .box-txt {
          flex: 1;
          h3 {
            color: #0ca6eb;
            font-size: 0.2947rem;
            margin: 0;
            padding-left: 0.7789rem;
            padding-bottom: 0.6316rem;
          }
          p {
            padding-left: 0.7789rem;
            color: #666666;
            line-height: 0.4632rem;
            font-size: 0.2526rem;
          }
        }
      }
    }
    .content-Iosbox {
      display: none;
      padding-top: 32px;
      @media screen and (max-width: 540px) {
        display: block;
      }
      .box {
        padding: 0 14px;
        padding-bottom: 32px;
        .pic {
          height: 260px;
          width: 100%;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .txt {
          padding: 18px;
          h3 {
            text-align: center;
            color: #0ca6eb;
            font-size: 15px;
          }
          p {
            font-size: 14px;
            line-height: 22px;
            color: #666666;
          }
        }
      }
    }
    .hezuo {
      padding: 0.7368rem 0 0.8421rem 0;
    }
  }
  .hezuo-content {
    // height: 7.5579rem;
    @media screen and (max-width: 540px) {
      background-color: #f5f5f5;
    }
    .cards {
      @media screen and (max-width: 540px) {
        display: none;
      }
      padding: 0.7263rem 0 0 0;
      .cardX {
        display: flex;
        justify-content: center;
        margin-bottom: 0.6842rem;
        .card {
          margin: 0 0.0842rem;
          width: 3.9368rem;
          height: 1.3684rem;
          display: flex;
          align-items: center;
          background-color: #fff;
          justify-content: center;
          border: 1px solid #eeeeee;
          border-radius: 0.0421rem;
          img {
            height: 100%;
            width: 100%;
          }
        }
      }
    }
    .cardIos {
      display: none;
      padding: 33px 0;
      @media screen and (max-width: 540px) {
        display: block;
        overflow: hidden;
      }
      .card {
        width: 30%;
        height: 44px;
        float: left;
        background-color: #fff;
        border: 1px solid #eeeeee;
        border-radius: 0.0421rem;
        display: flex;
        margin: 0 5px;
        margin-top: 10px;
        justify-content: center;
        align-items: center;
        img {
          height: 100%;
          width: 100%;
        }
      }
    }
    p {
      color: #c0c0c0;
      font-size: 0.2947rem;
      font-weight: 400;
      text-align: center;
      padding-bottom: 0.5263rem;
      @media screen and (max-width: 540px) {
        padding-bottom: 30px;
      }
    }
  }
}
</style>
